
$(function() {
  var resizeTimer;

  function syncAdvisorGroupHeights() {
    // Reset min-heights for larger screens

      $('.left_advisor .advisor-group-row, .right_advisor .advisor-group-row').css('min-height', '');

      var leftGroups = $('.left_advisor .advisor-group-row');
      var rightGroups = $('.right_advisor .advisor-group-row');

      var maxGroups = Math.max(leftGroups.length, rightGroups.length);

      for (var i = 0; i < maxGroups; i++) {
        var $left = leftGroups.eq(i);
        var $right = rightGroups.eq(i);
        var maxHeight = 0;

        if ($left.length) maxHeight = $left.outerHeight();
        if ($right.length && $right.outerHeight() > maxHeight) maxHeight = $right.outerHeight();

        if ($left.length) $left.css('min-height', maxHeight + 'px');
        if ($right.length) $right.css('min-height', maxHeight + 'px');
      }

  }

  $(window).on('load resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAdvisorGroupHeights, 250);
  });

  syncAdvisorGroupHeights();
});









/*
  $(window).on('load resize', function () {
  // Reset all heights first
  $('.newadvisor_list_box').css('height', 'auto');

  // Find the max height
  var maxHeight = 0;
  $('.newadvisor_list_box').each(function () {
    var boxHeight = $(this).outerHeight();
    if (boxHeight > maxHeight) {
      maxHeight = boxHeight;
    }
  });

  // Set all to tallest height
  $('.newadvisor_list_box').css('min-height', maxHeight + 'px');
});

$(document).ready(function () {
      // Reset all heights first
  $('.newadvisor_list_box').css('height', 'auto');

  // Find the max height
  var maxHeight = 0;
  $('.newadvisor_list_box').each(function () {
    var boxHeight = $(this).outerHeight();
    if (boxHeight > maxHeight) {
      maxHeight = boxHeight;
    }
  });

  // Set all to tallest height
  $('.newadvisor_list_box').css('min-height', maxHeight + 'px');

    });*/